import { PatientType } from "api/patientApi";
import { atom } from "recoil";

export const patientAtom = atom<PatientType | undefined>({
  key: "patient",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = localStorage.getItem("patient");
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);
          if (parsed && typeof parsed.patientId === "string") {
            const parsedId = Number(parsed.patientId);
            parsed.patientId = isNaN(parsedId) ? undefined : parsedId;
          }
          setSelf(parsed);
        } catch {
          // ignore parsing errors and reset local storage
          localStorage.removeItem("patient");
        }
      }

      // atom이 변화가 감지될 때 작동, Storage에 데이터 저장
      // setSelf에 의해서는 작동하지 않음
      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem("patient")
          : localStorage.setItem("patient", JSON.stringify(newValue));
      });
    },
  ],
});